import {} from "@/stores/workflowStepStore";
import Utils from "@/utils/utils";
class UntypedParameterReference {
    constructor(parameter, step) {
        Object.defineProperty(this, "stepId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        parameter.references.push(this);
        this.stepId = step.id;
    }
}
class ToolInputUntypedParameterReference extends UntypedParameterReference {
    constructor(parameter, step, toolInput) {
        super(parameter, step);
        // TODO: replace any when we have a defined tool state
        Object.defineProperty(this, "toolInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.toolInput = toolInput;
    }
}
class PjaUntypedParameterReference extends UntypedParameterReference {
    constructor(parameter, step, pja) {
        super(parameter, step);
        Object.defineProperty(this, "pja", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.pja = pja;
    }
}
class UntypedParameter {
    constructor(name) {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "references", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.references = [];
    }
    canExtract() {
        // Backend will indicate errors but would be a bit better to pre-check for them
        // in a future iteration.
        // return false if mixed input types or if say integers are used in PJA?
        return true;
    }
}
export class UntypedParameters {
    constructor() {
        Object.defineProperty(this, "parameters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.parameters = [];
    }
    getParameter(name) {
        for (const parameter of this.parameters) {
            if (parameter.name == name) {
                return parameter;
            }
        }
        const untypedParameter = new UntypedParameter(name);
        this.parameters.push(untypedParameter);
        return untypedParameter;
    }
    getParameterFromMatch(match) {
        return this.getParameter(match.substring(2, match.length - 1));
    }
}
export function getUntypedWorkflowParameters(steps) {
    const untypedParameters = new UntypedParameters();
    const parameter_re = /\$\{.+?\}/g;
    Object.values(steps).forEach((step) => {
        if (step.config_form?.inputs) {
            // TODO: with new tool state we could type this and drop the any
            Utils.deepEach(step.config_form.inputs, (d) => {
                if (typeof d.value == "string") {
                    const formMatches = d.value.match(parameter_re);
                    if (formMatches) {
                        for (const match of formMatches) {
                            const untypedParameter = untypedParameters.getParameterFromMatch(match);
                            new ToolInputUntypedParameterReference(untypedParameter, step, d);
                        }
                    }
                }
            });
        }
        if (step.post_job_actions) {
            Object.values(step.post_job_actions).forEach((pja) => {
                if (pja.action_arguments) {
                    Object.values(pja.action_arguments).forEach((action_argument) => {
                        if (typeof action_argument === "string") {
                            const arg_matches = action_argument.match(parameter_re);
                            if (arg_matches) {
                                for (const match of arg_matches) {
                                    const untypedParameter = untypedParameters.getParameterFromMatch(match);
                                    new PjaUntypedParameterReference(untypedParameter, step, pja);
                                }
                            }
                        }
                    });
                }
            });
        }
    });
    return untypedParameters;
}
